import { useCallback, useState } from 'react'
import { CopyIcon } from '@/atoms/Icons/CopyIcon'
import { ParagraphSM } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { AudienceInterestTermsAndConditions } from './AudienceInterestTermsAndConditions'

interface AudienceInterestTextProps {
  title: string
  description: string
  isTermsAndConditions?: boolean
  isStreaming?: boolean
  ticketCode?: string | null
}

export const AudienceInterestText = ({
  title,
  description,
  isTermsAndConditions = false,
  isStreaming = false,
  ticketCode,
}: AudienceInterestTextProps) => {
  const { t } = useTranslate('guild-voting')
  const [isCopied, setIsCopied] = useState(false)

  const onCopyPressed = useCallback(() => {
    setIsCopied(true)
    navigator.clipboard.writeText(ticketCode ?? '')
    setTimeout(() => {
      setIsCopied(false)
    }, 2000)
  }, [ticketCode])

  return (
    <div className="z-30 flex flex-col gap-3">
      <span className="text-2xl font-bold text-white">{title}</span>
      <div className="flex flex-col gap-2">
        <span className="text-sm text-core-gray-400">{description}</span>
        {ticketCode && (
          <div className="flex cursor-pointer items-center gap-2" onClick={onCopyPressed}>
            <ParagraphSM className="text-white">{ticketCode}</ParagraphSM>
            <span>-</span>
            {isCopied ? (
              <span className=" flex items-center justify-center text-xs ">{t('copied', 'Copied!')}</span>
            ) : (
              <CopyIcon size={16} color="white" />
            )}
          </div>
        )}
      </div>
      {isTermsAndConditions ? <AudienceInterestTermsAndConditions isStreaming={isStreaming} /> : null}
    </div>
  )
}
